import trimWhiteSpace from './trimWhiteSpace';

const emailMaxLen = (value) => {
    if (value == null || trimWhiteSpace(value).length > 100) {
        return 'Your email address cannot be greater than 100 characters.';
    }
    return undefined;
};

export default emailMaxLen;



// WEBPACK FOOTER //
// ./src/client/utils/emailMaxLen.js